import { STEPS } from "../data/content";

export const HowItWorksSteps = ({ full = false }) => (
  <ol className="grid gap-px bg-slate-200 border border-slate-200 md:grid-cols-2 lg:grid-cols-4" data-testid="how-it-works-steps">
    {STEPS.map((s, i) => (
      <li key={s.n} className={`relative bg-white p-7 lg:p-8 group hover:bg-[#F7F8FA] transition-colors rise d${i + 1}`} data-testid={`step-${s.n}`}>
        <div className="flex items-center justify-between">
          <span className="font-display font-black text-6xl text-transparent [-webkit-text-stroke:1.5px_#F59E0B] group-hover:text-orange-600 transition-colors">{s.n}</span>
          <span className="h-px flex-1 ml-4 bg-gradient-to-r from-amber-500/60 to-transparent" />
        </div>
        <h3 className="mt-6 font-display font-bold uppercase text-slate-900 text-xl leading-tight tracking-wide">{s.title}</h3>
        <p className={`mt-4 text-slate-600 text-sm leading-relaxed ${full ? "" : "line-clamp-5"}`}>{s.body}</p>
      </li>
    ))}
  </ol>
);
